import {makeStyles, Portal} from "@material-ui/core";
import {styles} from "../utils/styles";
import clsx from "clsx";
import {useParams} from "react-router";
import {useSelector} from "react-redux";
import Iframe from "react-iframe";
import {contentNoPaddingRef} from "../utils/utilities";
import { useEffect, useRef } from "react";

const useStyles = makeStyles((theme) => ({
	...styles
}));

function BrandInformation() {
	const containerRef = useRef(null)

	// this id is the brand number
	const {id} = useParams();
	const classes = useStyles();
	const brands = useSelector((state) => state.brands.brands);
	const matchingBrand = brands.find((b) => b.number.toString() === id);

	const url = matchingBrand['pageUrl'];

	useEffect(() => {
		if (!url || !containerRef.current) return;

		// check if it's a <script> tag string
		if (url.startsWith("<script")) {
			// extract the src value using a simple regex
			const match = url.match(/src=['"]([^'"]+)['"]/i);
			const src = match?.[1];

			if (src) {
				const script = document.createElement("script");
				script.src = src;
				script.async = true;

				containerRef.current.innerHTML = '';
				containerRef.current.appendChild(script);

				return () => {
					if (containerRef.current?.contains(script)) {
						containerRef.current.removeChild(script);
					}
				};
			}
		}
	}, [url]);

	return (
		!matchingBrand ?
			<div className={clsx(classes.column, classes.alignCenterCenter, "flex")}>
				<span>Brand Not Found!</span>
			</div> :
			<Portal container={contentNoPaddingRef.current} disablePortal={!!url.startsWith('<script')}>
				{url.startsWith('<script') ?
					<div className='flex' ref={containerRef} style={{ overflowY: 'auto' }} /> :
					<Iframe
						url={matchingBrand['pageUrl']}
						className={clsx(classes.iFrame, "flex")}
					/>
				}
			</Portal>
	);
}

export default BrandInformation;